import "./BackBar.css";
import React from "react";

const BackBar = ({
  onBack,
  leftLabel = "Retour",
  showLabel = true,
  children,
  offsetTopPx = 64,
  title,
}) => {
  const handleBack = React.useCallback(() => {
    if (onBack) return onBack();
    if (typeof window !== "undefined") {
      if (window.history.length > 1) window.history.back();
      else window.location.assign("/");
    }
  }, [onBack]);

  return (
    <div
      className="back-bar"
      style={{ "--backbar-top": `${offsetTopPx}px` }}
      role="region"
      aria-label="Barre de navigation locale"
    >
      {null}
      <div className="back-bar-inner">
        <button
          type="button"
          onClick={handleBack}
          aria-label="Revenir à l'écran précédent"
          className="back-bar-btn"
        >
          <span className="back-arrow" aria-hidden>
            ←
          </span>
          {showLabel ? <span>{leftLabel}</span> : null}
        </button>

        <div className="back-bar-right">{children}</div>
      </div>
    </div>
  );
};

export default BackBar;
